(function () {
  var HOST_ID = 'recharge-storefront-experiences__cart-overlay';

  function injectFix(shadowRoot) {
    if (shadowRoot.querySelector('style[data-zindex-fix]')) return;

    var style = document.createElement('style');
    style.setAttribute('data-zindex-fix', 'true');
    style.textContent = '[data-state="open"].fixed.inset-0 { z-index: 2147483647 !important; }';
    shadowRoot.appendChild(style);
  }

  function tryFix() {
    var host = document.getElementById(HOST_ID);
    if (host && host.shadowRoot) {
      injectFix(host.shadowRoot);
    }
  }

  tryFix();

  var observer = new MutationObserver(tryFix);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
